// @ts-nocheck
import { AppEnvironment, environment as common } from '@env/environment.common';

export const environment: AppEnvironment = {
  production: true,
  name: 'staging',
  values: {
    ...common.values,
    dwspayPublishKey: 'pk_test_51SypacQ0w9MN8n1XTiNfWdmQwfDXfg7VX87YsfWVoaVK15LYcI6oUyPEjSp3ilZY7CQ0AZh1Vw5uSXXVvSmI5zZn00MF5RgvBm'
  },
  hosts: {
    wsb2c: {
      host: 'api-staging-b2c.b2c.wine-suite.com',
      protocol: 'https',
      port: '',
      root: '/api/public/',
      endpoints: {}
    }
  }
};
